import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxSignPdfComponent } from './ngx-sign-pdf/ngx-sign-pdf.component';

const routes: Routes = [
  {
      
    path: 'home',
    component:NgxSignPdfComponent,
  
},
{ path: '', redirectTo: '/home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
